import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, Legend } from "recharts";

const PIE_COLORS = ["#059669", "#0D9488", "#0284C7", "#D97706", "#DC2626"];

export default function MetricsCharts({ stats }) {
  return (
    <div className="grid lg:grid-cols-3 gap-6">
      <div className="lg:col-span-2 bg-white rounded-2xl border border-slate-200 p-6">
        <h3 className="font-heading font-extrabold text-slate-900 mb-4">Relawan & Jam per Bulan (2026)</h3>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={stats.monthly}>
            <XAxis dataKey="month" tick={{ fontSize: 12 }} />
            <YAxis tick={{ fontSize: 12 }} />
            <Tooltip />
            <Legend />
            <Bar dataKey="relawan" name="Relawan" fill="#059669" radius={[6, 6, 0, 0]} />
            <Bar dataKey="jam" name="Jam Kontribusi" fill="#0D9488" radius={[6, 6, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="bg-white rounded-2xl border border-slate-200 p-6">
        <h3 className="font-heading font-extrabold text-slate-900 mb-4">Distribusi per Kategori (%)</h3>
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie data={stats.by_category} dataKey="value" nameKey="name" innerRadius={55} outerRadius={90} paddingAngle={3}>
              {stats.by_category.map((_, i) => <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />)}
            </Pie>
            <Tooltip />
            <Legend wrapperStyle={{ fontSize: 12 }} />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
